import React from "react"
import styles from "./Skeleton.module.scss"

const Skeleton: React.FC = () => {
    return <div className={styles.container__skeleton} role="status" />
}

export default Skeleton
